// Central data-testid constants (kebab-case)
export const NAV = {
  logo: "nav-logo",
  landing: "nav-landing-link",
  jobs: "nav-jobs-link",
  learning: "nav-learning-link",
  mentors: "nav-mentors-link",
  contact: "nav-contact-link",
  dashboard: "nav-dashboard-link",
  login: "nav-login-button",
  logout: "nav-logout-button",
  userMenu: "nav-user-menu",
};

export const LANDING = {
  heroCta: "hero-primary-cta",
  heroSecondary: "hero-secondary-cta",
  waitlistEmail: "waitlist-email-input",
  waitlistName: "waitlist-name-input",
  waitlistPersona: "waitlist-persona-select",
  waitlistSubmit: "waitlist-submit-button",
  waitlistSuccess: "waitlist-success-message",
  personaIndividual: "persona-card-individual",
  personaStartup: "persona-card-startup",
  personaCorporate: "persona-card-corporate",
  personaInvestor: "persona-card-investor",
};

export const CONTACT = {
  name: "contact-name-input",
  email: "contact-email-input",
  org: "contact-org-input",
  persona: "contact-persona-select",
  subject: "contact-subject-input",
  message: "contact-message-input",
  submit: "contact-submit-button",
  success: "contact-success-message",
  error: "contact-error-message",
  supportEmail: "footer-support-email",
  parentCompany: "footer-parent-company",
  termsLink: "footer-terms-link",
  privacyLink: "footer-privacy-link",
  refundLink: "footer-refund-link",
  contactLink: "footer-contact-link",
};

export const AUTH = {
  googleButton: "google-signin-button",
  callbackStatus: "auth-callback-status",
};

export const ASSESS = {
  personaSelect: (p) => `assessment-persona-${p}`,
  answerOption: (qid, val) => `assessment-answer-${qid}-${val}`,
  next: "assessment-next-button",
  back: "assessment-back-button",
  submit: "assessment-submit-button",
  profileBackground: "assessment-profile-background",
  profileGoals: "assessment-profile-goals",
};

export const DASH = {
  scoreBand: "dashboard-score-band",
  overallScore: "dashboard-overall-score",
  radar: "dashboard-radar-chart",
  startAssessment: "dashboard-start-assessment",
  aiSummary: "dashboard-ai-summary",
};

export const HOME = {
  emergentLink: "emergent-link",
};
